import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import * as State from '../State';
import * as KnowledgeBase from '../types/KnowledgeBase';
import { Handlers } from '../useState';

interface Props {
	state: State.Type;
	handlers: Handlers;
}

export default function Overview({ state, handlers }: Props) {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return (
		<div>
			{state.knowledgeBases.map((knowledgeBase: KnowledgeBase.Type) => (
				<div
					key={knowledgeBase.id}
					className={classes.knowledgeBase}
					onClick={() => handlers.setCurrentKnowledgeBaseId(knowledgeBase.id)}
				>
					<div className={classes.knowledgeBaseName}>{knowledgeBase.name}</div>
					<div className={classes.knowledgeBaseDocuments}>
						{t('admin:DOCUMENTS')}: {knowledgeBase.documents.length}
					</div>
				</div>
			))}
		</div>
	);
}

export const useStyles = tss.create({
	knowledgeBaseName: {
		fontSize: '20px',
		fontWeight: 'bold',
	},
	document: {
		marginLeft: '20px',
		fontSize: '16px',
		marginBottom: '10px',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	knowledgeBase: {
		cursor: 'pointer',
		padding: '10px',
		border: '1px solid #ccc',
		marginBottom: '-1px',
		'&:hover': {
			backgroundColor: '#f0f0f0',
		},
	},
	knowledgeBaseDocuments: {
		fontSize: '16px',
		display: 'flex',
		flexDirection: 'row',
	},
});
